import * as React from "react";
import { RecommendationCell } from "./StatusIcon";

interface Props {
  result: ClientSiteAssessmentResultsDTO;
}

export const VitalsRecommendationCell: React.FC<Props> = ({ result }) => (
  <RecommendationCell
    status={result.vitalsStatusId}
    dateCompleted={result.vitalsDateCompleted}
    testId={result.vitalsTestResultId}
  />
);
